// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import Plotly from 'plotly.js/dist/plotly'
import './assets/icon/iconfont.css'
import './assets/ali_icon/iconfont.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import JsonExcel from 'vue-json-excel'
import htmlToPdf2 from '@/utils/htmlToPdf2'
import '@/style/index.scss'
import * as echarts from 'echarts'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

Vue.use(Autocomplete)
Vue.prototype.$echarts = echarts

Vue.use(ElementUI, { locale })
Vue.use(Plotly)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(htmlToPdf2)
Vue.config.productionTip = false
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js